module.exports = __webpack_public_path__ + "img/13.f9b568ba.jpg";